(function () {
 if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) { return; }
 var selector = "header-component, cart-drawer .drawer__inner, search-modal .search-modal__content, quick-add-modal .quick-add-modal__content, .quick-add-modal__content";

 function attach(el) {
 if (el.__lgAttached) { return; }
 el.__lgAttached = true;
 el.addEventListener("pointermove", function (e) {
 var rect = el.getBoundingClientRect();
 if (rect.width === 0 || rect.height === 0) { return; }
 var x = ((e.clientX - rect.left) / rect.width) * 100;
 var y = ((e.clientY - rect.top) / rect.height) * 100;
 el.style.setProperty("--lg-x", x + "%");
 el.style.setProperty("--lg-y", y + "%");
 });
 el.addEventListener("pointerleave", function () {
 el.style.removeProperty("--lg-x");
 el.style.removeProperty("--lg-y");
 });
 }

 function scan() {
 document.querySelectorAll(selector).forEach(attach);
 }

 if (document.readyState === "loading") {
 document.addEventListener("DOMContentLoaded", scan);
 } else {
 scan();
 }

 var mo = new MutationObserver(function () { scan(); });
 mo.observe(document.body, { childList: true, subtree: true });
})();
